module.exports = __webpack_public_path__ + "img/progress0.b12fc983.png";